/*
  رسائل Toast صغيرة غير مزعجة — مستقلة عن SweetAlert2 حتى تظهر مع أي نافذة مفتوحة
  ولا تغلقها، ولا تمنع التفاعل مع الصفحة. تختفي تلقائياً بعد ثوانٍ، ويمكن إغلاقها بالنقر.
  الأنماط في styles/toast.css (مقاسات من رموز theme.css، وتعمل على الجوال وRTL/LTR).
*/
import "../styles/toast.css";

const ICONS = { success: "✓", error: "✕", warning: "!", info: "i" };
let container = null;

function ensureContainer() {
  if (container && document.body.contains(container)) return container;
  container = document.createElement("div");
  container.className = "asf-toasts";
  container.setAttribute("role", "status");
  container.setAttribute("aria-live", "polite");
  container.setAttribute("data-testid", "toast-container");
  document.body.appendChild(container);
  return container;
}

/**
 * يعرض رسالة Toast.
 * @param {string} message نص الرسالة
 * @param {{type?: "success"|"error"|"warning"|"info", duration?: number, id?: string}} options
 *   id: رسالة بنفس المعرّف تستبدل السابقة بدل أن تتكرر.
 */
export function showToast(message, { type = "info", duration = 4000, id } = {}) {
  if (typeof document === "undefined" || !message) return;
  const box = ensureContainer();
  if (id) box.querySelectorAll(`[data-toast-id="${CSS.escape(id)}"]`).forEach((n) => n.remove());
  const el = document.createElement("div");
  el.className = `asf-toast asf-toast--${type}`;
  el.setAttribute("data-testid", "toast");
  el.setAttribute("data-type", type);
  if (id) el.setAttribute("data-toast-id", id);
  const icon = document.createElement("span");
  icon.className = "asf-toast__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.textContent = ICONS[type] || ICONS.info;
  const text = document.createElement("span");
  text.className = "asf-toast__text";
  text.textContent = message;
  el.append(icon, text);
  const close = () => {
    el.classList.add("is-leaving");
    setTimeout(() => el.remove(), 200);
  };
  el.addEventListener("click", close);
  box.appendChild(el);
  // أقصى ثلاث رسائل ظاهرة
  while (box.children.length > 3) box.firstElementChild.remove();
  setTimeout(close, duration);
}

export const toast = {
  success: (m, o) => showToast(m, { ...o, type: "success" }),
  error: (m, o) => showToast(m, { ...o, type: "error" }),
  warning: (m, o) => showToast(m, { ...o, type: "warning" }),
  info: (m, o) => showToast(m, { ...o, type: "info" }),
};

export default toast;
